import {
  CREATE_SAVED_SEARCH_REQUEST,
  CREATE_SAVED_SEARCH_SUCCESS,
  CREATE_SAVED_SEARCH_FAILURE,
  DELETE_SAVED_SEARCH_REQUEST,
  DELETE_SAVED_SEARCH_SUCCESS,
  DELETE_SAVED_SEARCH_FAILURE,
  FETCH_SAVED_SEARCHES_REQUEST,
  FETCH_SAVED_SEARCHES_SUCCESS,
  FETCH_SAVED_SEARCHES_FAILURE,
} from '../actions/actionTypes'

const initialState = {
  data: [],
  loading: true,
}

const reducer = (state = initialState, action) => {
  const { error, type } = action
  switch (type) {
    case CREATE_SAVED_SEARCH_REQUEST:
    case FETCH_SAVED_SEARCHES_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case DELETE_SAVED_SEARCH_REQUEST:
      return {
        ...state,
        loading: false,
      }
    case CREATE_SAVED_SEARCH_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.savedSearch],
        loading: false,
      }
    case FETCH_SAVED_SEARCHES_SUCCESS:
      return {
        ...state,
        data: action.savedSearches,
        loading: false,
      }
    case DELETE_SAVED_SEARCH_SUCCESS:
      return {
        ...state,
        data: state.data.filter(
          savedSearch =>
            savedSearch.locationId !== action.savedSearch.locationId
        ),
        loading: false,
      }
    case CREATE_SAVED_SEARCH_FAILURE:
    case FETCH_SAVED_SEARCHES_FAILURE:
    case DELETE_SAVED_SEARCH_FAILURE:
      return {
        ...state,
        error,
        loading: false,
      }
    default:
      return state
  }
}

export default reducer
